import React from 'react';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { GlobalViewTaxForm } from './global-viewtaxform';
import { ViewTaxFormPropTypes } from '../../shapes';

export const BATaxViewTaxForm = props => (
  <GlobalViewTaxForm
    {...props}
    countryCode={Constants.CountryCode.BA}
    showTaxCert={false}
  />
);

BATaxViewTaxForm.propTypes = ViewTaxFormPropTypes;
